<template>
  <div>
    <div class="mb-3 row">
      <div class="col-md-12">
        <base-button class="mb-3 mb-sm-0"
                     type="button"
                     :disabled="!dataReady"
                     @click="changeSortBy('popular')"
                     :class="[ by === 'popular' ? 'bg-blue text-white' : 'bg-secondary text-black-50']"
                     :icon="{ prefix: 'fas', iconName: 'chart-line'}">
          Popular
        </base-button>
        <base-button :disabled="!dataReady"
                     class="mb-3 mb-sm-0"
                     type="button"
                     @click="changeSortBy('featured')"
                     :class="[ by === 'featured' ? 'bg-blue text-white' : 'bg-secondary text-black-50']"
                     :icon="{ prefix: 'fas', iconName: 'star'}">
          Featured
        </base-button>
        <base-button :disabled="!dataReady"
                     class="mb-3 mb-sm-0"
                     type="button"
                     @click="changeSortBy('new')"
                     :class="[ by === 'new' ? 'bg-blue text-white' : 'bg-secondary text-black-50']"
                     :icon="{ prefix: 'fas', iconName: 'newspaper'}">
          New
        </base-button>
        <base-button
          :disabled="!dataReady"
          class="mb-3 mb-sm-0"
          type="button"
          @click="changeSortBy('ptwisters')"
          :class="[ by === 'ptwisters' ? 'bg-blue text-white' : 'bg-secondary text-black-50']"
          :icon="{ prefix: 'fas', iconName: 'shapes'}">
          PTwisters' Things
        </base-button>
        <span v-if="!dataReady">
          <bounce-loader class="d-inline-block"
                         size="30px" style="margin-bottom:-10px;">
          </bounce-loader>
          <span class="ml-3 text-muted">Collecting previews from thingiverse...</span>
        </span>
      </div>
    </div>
    <div class="text-center">
      <a href="https://www.thingiverse.com/groups/plastictwist/things" target="_blank">
        <base-button
          class="mb-3 mb-sm-0 bg-green text-white"
          type="button"
          @click="changeSortBy('ptwisters')"
          :icon="{ prefix: 'fas', iconName: 'upload'}">
          upload your own designs!
        </base-button>
      </a>
    </div>
    <repositories-masonry class="mt-3" v-if="things.length > 0" :things="things"></repositories-masonry>
    <no-data-error v-if="things.length === 0"></no-data-error>
    <ptwist-loading v-else-if="!dataReady"></ptwist-loading>
    <server-error v-else-if="error"></server-error>
  </div>

</template>
<script>
import BounceLoader from 'vue-spinner/src/BounceLoader.vue'

export default {
  name: 'thingiverse-repository',
  components: {
    BounceLoader
  },
  data () {
    return {
      loading: true,
      by: 'popular',
      dataReady: false,
      things: [],
      error: false
    }
  },
  mounted () {
    this.update()
  },
  methods: {
    update () {
      this.dataReady = false
      this.things = []
      let payload = this.getPayload()
      this.$store
        .dispatch('api/get', payload)
        .then(async response => {
          this.things = []
          this.interrupt = false
          await this.getThingiverseEmbeddings(response.data)
          this.dataReady = true
        }).catch(error => {
          console.error(error)
          this.error = true
        }).finally(() => {
          this.loading = false
        })
    },
    getPayload () {
      if (this.by === 'ptwisters') {
        return {
          endpoint: 'thingiverse/ptwisters'
        }
      } else {
        return {
          data: {
            by: this.by
          },
          endpoint: 'thingiverse/top-things'
        }
      }
    },
    async getThingiverseEmbeddings (things) {
      for (let value of things) {
        let payload = {
          data: {
            'id': value.id
          },
          endpoint: 'embeddings/thingiverse'
        }
        await this.$store
          .dispatch('api/get', payload)
          .then(response => {
            this.things.push(response.data)
          })
          .catch(error => {
            console.error(error)
            this.loading = false
            this.error = true
          })
      }
    },
    changeSortBy (by) {
      this.by = by
      this.update()
    }
  }
}
</script>
